import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TransactionOverlay from '../components/transactions/TransactionOverlay';
import ReceivePaymentUpdate from './payments/ReceivePaymentUpdate';
import type { CustomerPayment } from '../types/customerPayment';
import { useReceivePaymentsHub } from './ReceivePaymentsHubContext';

const ReceivePaymentsPaymentAllocationsOverlay = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { refetchInvoices } = useReceivePaymentsHub();

  const parsedId = id != null ? Number(id) : Number.NaN;
  const paymentId = Number.isNaN(parsedId) || parsedId <= 0 ? undefined : parsedId;

  const close = useCallback(() => {
    navigate('/receive-payments', { preventScrollReset: true });
  }, [navigate]);

  const handlePaymentSaved = useCallback(
    (_payment: CustomerPayment) => {
      refetchInvoices();
      close();
    },
    [close, refetchInvoices]
  );

  return (
    <TransactionOverlay headerless variant="wide" onClose={close}>
      <div className="flex flex-1 min-h-0 flex-col">
        <ReceivePaymentUpdate
          key={paymentId}
          embedded
          paymentId={paymentId}
          onClose={close}
          onPaymentSaved={handlePaymentSaved}
        />
      </div>
    </TransactionOverlay>
  );
};

export default ReceivePaymentsPaymentAllocationsOverlay;
